// GTM event driven by the CMS
export const gtmEventTypes = {
  BADGE_CLICK: 'CMS-GLH-001',
  CLICK_ICON: 'CMS-GLH-002',
  NAV_LINK_CLICK: 'CMS-GLH-003',
  NAV_LINK_SECONDARY_CLICK: 'CMS-GLH-004',
  HAMBURGER_EXPAND: 'CMS-GLH-005',
  HAMBURGER_COLLAPSE: 'CMS-GLH-006',
  OVERLAY_CLOSED: 'CMS-GLH-007',
  CLOSED_MORE: 'CMS-GLH-008',
}

export const gtmEvents = {
  [gtmEventTypes.BADGE_CLICK]: () => ({
    type: gtmEventTypes.BADGE_CLICK,
    event: 'reactjs.event',
    eventID: gtmEventTypes.BADGE_CLICK,
    pageCategory: 'Header Nav',
    pageAction: 'Nav - Clicked home badge',
  }),
  [gtmEventTypes.CLICK_ICON]: ({CMSGroupGTM, itemName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_ICON,
    event: 'reactjs.event',
    pageAction: `${CMSGroupGTM.action} - Clicked "${itemName.toUpperCase()}"`,
  }),
  [gtmEventTypes.NAV_LINK_CLICK]: ({
                                     CMSGroupGTM,
                                   }) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.NAV_LINK_CLICK,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action,
  }),
  [gtmEventTypes.NAV_LINK_SECONDARY_CLICK]: ({
                                               CMSGroupGTM,
                                             }) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.NAV_LINK_SECONDARY_CLICK,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action,
  }),
  [gtmEventTypes.HAMBURGER_EXPAND]: () => ({
    type: gtmEventTypes.HAMBURGER_EXPAND,
    event: 'reactjs.event',
    eventID: gtmEventTypes.HAMBURGER_EXPAND,
    pageCategory: 'Header Nav',
    pageAction: 'Nav - Expanded hamburger menu',
  }),
  [gtmEventTypes.HAMBURGER_COLLAPSE]: () => ({
    type: gtmEventTypes.HAMBURGER_COLLAPSE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.HAMBURGER_COLLAPSE,
    pageCategory: 'Header Nav',
    pageAction: 'Nav - Collapsed hamburger menu',
  }),
  [gtmEventTypes.OVERLAY_CLOSED]: ({
                                     CMSGroupGTM,
                                   }) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.OVERLAY_CLOSED,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action,
  }),
  [gtmEventTypes.CLOSED_MORE]: () => ({
    type: gtmEventTypes.CLOSED_MORE,
    event: 'reactjs.event',
    eventID: gtmEventTypes.CLOSED_MORE,
    pageCategory: 'Header Nav',
    pageAction: 'Nav  - Closed "MORE"',
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/global-nav-duck.js